import { FunctionalComponent, h } from 'preact';

import { MyNotesModel } from 'common/data/my-notes/model';
import { MyAccountListTypeEnum } from 'common/module/my-account/list-type.enum';
import { MyNotesNoteTemplate } from 'common/module/my-notes/note/template';
import { MyNotesNoteViewStoreFactory } from 'common/module/my-notes/note/view-store.factory';
import { preactDynamicComponent } from 'common/module/preact/dynamic/component';

const MyNotesNote = preactDynamicComponent(MyNotesNoteTemplate);

export const MyNotesNoteComponent: FunctionalComponent<{
  model: MyNotesModel;
  listType: MyAccountListTypeEnum;
  onClickDelete(model: MyNotesModel): void;
}> = (props) => {
  const store = MyNotesNoteViewStoreFactory();

  store.initialize({
    model: props.model,
    onClickDelete: props.onClickDelete,
    listType: props.listType,
  });

  return <MyNotesNote viewStore={store} />;
};
